export default "__VITE_ASSET__Bs0t_JUo__"